import { apiClient } from '@/services/api';
import type { AdminAuthPayload, ApiResponse } from '@/types/auth';

export interface AdminLoginInput {
  email: string;
  password: string;
}

class AdminAuthService {
  login(input: AdminLoginInput) {
    return apiClient.post<ApiResponse<AdminAuthPayload>>('/auth/admins/login', input);
  }

  /** Pass the token explicitly: callers clear local storage before this request goes out. */
  logout(accessToken: string) {
    return apiClient.post<ApiResponse>('/auth/admins/logout', undefined, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }
}

export const adminAuthService = new AdminAuthService();
